import { render, staticRenderFns } from "./editProductionCompany.vue?vue&type=template&id=1c9f04e8&"
import script from "./editProductionCompany.vue?vue&type=script&lang=js&"
export * from "./editProductionCompany.vue?vue&type=script&lang=js&"
import style0 from "./editProductionCompany.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports